export default __webpack_public_path__ + "static/Deccan-f679e0e57348fa409a0dcb324cb2284b.png";